module.exports = __webpack_public_path__ + "static/media/theMoon.8b9b653d.png";